const exerciseScale = {
  REP: 2,
  WEIGHT: 4,
  SETS: 8,
  DURATION: 16,
  DISTANCE: 32
} as const;

export type ExerciseScale = keyof typeof exerciseScale;
export default exerciseScale;